import type { VoidComponent } from "solid-js";
import { DestructiveModal } from "../../../components/modal/Modal.tsx";
import { useTranslation } from "../../../state/i18n.tsx";
import GenericFailureModal from "../../GenericFailureModal.tsx";
import ApiService from "../../../services/ApiService.ts";
import { useModalManager } from "../../../components/modal/ModalManager.tsx";
import type FormId from "../../../state/FormId.ts";
import type TaskId from "../../../state/TaskId.ts";
import { MoreAppError } from "../../../MoreAppError.ts";
import DeleteTaskExistingSubmissionsModal from "./DeleteTaskExistingSubmissionsModal.tsx";

type DeleteTaskConfirmationModalProps = {
  formId: FormId;
  taskId: TaskId;
};

const DeleteTaskConfirmationModal: VoidComponent<DeleteTaskConfirmationModalProps> = (props) => {
  const { t } = useTranslation();
  const { replace } = useModalManager();

  return (
    <DestructiveModal
      title={t(($) => $.DELETE_TASK_CONFIRMATION_MODAL_TITLE)}
      description={t(($) => $.DELETE_TASK_CONFIRMATION_MODAL_DESCRIPTION)}
      confirmLabel={t(($) => $.DELETE_TASK_CONFIRMATION_MODAL_ACTIONS_CONFIRM)}
      cancelLabel={t(($) => $.DELETE_TASK_CONFIRMATION_MODAL_ACTIONS_CANCEL)}
      onConfirm={() =>
        ApiService.deleteTask()
          .mutateAsync({ formId: props.formId, taskId: props.taskId })
          .catch((err) => {
            // Submissions might have been made in the meantime, in that case show the same modal
            if (err instanceof MoreAppError && err.code === "cannot_delete_task_with_fulfilments") {
              replace({
                content: () => <DeleteTaskExistingSubmissionsModal />,
              });
            } else {
              replace({
                content: () => <GenericFailureModal error={err} />,
              });
            }

            throw err;
          })
      }
    />
  );
};

export default DeleteTaskConfirmationModal;
